export default __webpack_public_path__ + "static/media/25101301.b8014e36.jpg";